import type { ChangeEvent, FunctionComponent } from 'react';
import { ReactComponent as ShoppingCreditIcon } from '../../../assets/svg/shopping-credit-icon.svg';
import * as styles from './ShoppingCredit.module.scss';

export interface ShoppingCreditProps {
  shoppingCredit: number;
  onClick: (state: boolean) => void;
  error: boolean;
  label: string;
}

const ShoppingCredit: FunctionComponent<ShoppingCreditProps> = ({
  shoppingCredit,
  onClick,
  error,
  label,
}) => {
  const handleClickCheckBox = (event: ChangeEvent<HTMLInputElement>) => {
    onClick(event.target.checked);
  };

  return (
    <div className={styles.shoppingCreditContainer} data-testid="shopping-credit-container">
      <div className={styles.pinkShoppingCreditContainer}>
        <ShoppingCreditIcon aria-hidden="true" alt="Shopping Credit Icon" />
        <div>
          <h1>
            Wait, You Have{' '}
            {(shoppingCredit / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}{' '}
            Shopping Credits!
          </h1>
          <p>
            If you cancel, your credits will permanently expire at the end of your membership
            period. Are you sure you want to continue?
          </p>
        </div>
      </div>
      <div className={styles.checkboxContainer}>
        {error && <p>*Required - Please check this box if you want to proceed.</p>}
        <label htmlFor="checkbox-shopping-credit" className={styles.checkboxLabel}>
          <input
            type="checkbox"
            key="checkbox-shopping-credit"
            id="checkbox-shopping-credit"
            onChange={handleClickCheckBox}
          />
          <span className={styles.checkbox} />
          <span>{label}</span>
        </label>
      </div>
    </div>
  );
};

export default ShoppingCredit;
